import { Component, input, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-duplicate-setup',
  templateUrl: './modal-duplicate-setup.html',
  styleUrl: './modal-duplicate-setup.scss',
  standalone: false
})
export class ModalDuplicateSetup implements OnInit {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly routes = input<any>();
  readonly loading = input<boolean>(false);
  readonly action = output<any>();

  public images = images;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json'
  };

  public routeSelected = 0;

  public formGroup: FormGroup = new FormGroup({});

  constructor(public literalService: LiteralService, public utilsService: UtilsService, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(async (params) => {
      this.routeSelected = Number(params.get('routeId'));
    });
    this.setControls();
    this.formGroup.get('route')?.setValue(this.routeSelected);
  }

  setControls() {
    this.formGroup.addControl('name', new FormControl('', [Validators.required]));
    this.formGroup.addControl('route', new FormControl('', [Validators.required]));
  }

  setSetupName(event: any) {
    this.formGroup.get('name')?.setValue(event.target.value);
  }

  setRoute(event: any) {
    this.formGroup.get('route')?.setValue(event.value);
  }

  onSubmit() {
    this.action.emit({
      name: this.formGroup.get('name')?.value,
      route: this.formGroup.get('route')?.value
    });
    this.modal()?.hide();
    this.resetForm();
  }

  private resetForm() {
    this.formGroup.get('name')?.setValue('');
    this.formGroup.get('route')?.setValue(this.routeSelected);
  }

}
